export default "__VITE_ASSET__NkwfRukI__"